var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavigateRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "20px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "1.5166 20.5437 0.4834 19.4563 9.91115 10.5 0.4834 1.5437 1.5166 0.4563 12.08885 10.5"
})));
export { SvgNavigateRight as ReactComponent };